import React from 'react'
import cn from 'classnames'
import s from './BubbleTitle.scss'
import sLay from 'styles/modules/layout.scss'
import Markdown from 'features/Markdown'
import sText from 'components/Text/Text.scss'

export default ({ title, text, color }) =>
  title || text ? (
    <div className={cn(s.section, sLay['layout-row'], sLay['layout-align-start-start'])}>
      <div className={title ? sLay['flex-50'] : ''}>
        {text && <Markdown text={text} color={color} />}
      </div>
      <div className={sLay.flex} />
      {title && <div className={cn(s.bubble, sText.heading2)}>{title}</div>}
    </div>
  ) : null



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BubbleTitle/BubbleTitle.jsx